import { uniqueItemsFilter } from './unique.filter';
export const FiltersModule = angular
  .module('sfMobile.filters', [])
  .filter('unique', uniqueItemsFilter).name;
